import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

/**
 * Markdown do produto. Usa react-markdown + remark-gfm (GitHub Flavored Markdown):
 * tabela, checklist, ~riscado~ e autolink — que o parser artesanal anterior não
 * suportava, e por isso o calendário editorial saía com os pipes crus na tela.
 *
 * Segurança: SEM rehype-raw de propósito. O conteúdo vem de LLM (não confiável) e,
 * sem esse plugin, qualquer HTML no texto é tratado como texto e escapado — mesma
 * garantia do escapeHtml() que existia antes. Não adicione rehype-raw sem
 * rehype-sanitize junto.
 */
export default function Markdown({ text = "", className = "" }) {
  if (!text) return null;
  return (
    <div className={`markdown-body ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          // Tabela larga não pode empurrar a página no celular: rola dentro do
          // próprio bloco (mesma regra do overflow-wrap adotada no Epic 13).
          table: ({ node, ...props }) => (
            <div className="md-table-wrap">
              <table {...props} />
            </div>
          ),
          input: ({ node, ...props }) => (
            <input {...props} disabled className="md-task" />
          ),
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
